import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
/** `DELETE …/lists/{list}/items/{index}` — `index` is 0-indexed. */
class RemoveDocumentListItem {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly documentId: number,
		public readonly listKey: string,
		public readonly index: number,
	) {
		Object.freeze(this);
	}
}

export default RemoveDocumentListItem;
